/* eslint-disable */ import { composedOfComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const adminComponents = [
    attachAdminComponent.withComponent(composedOfComponent, '$customMaterials', true).withEntity('Admin').attach(memoEval((self)=>self.$customMaterials.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$countersinks', true).withEntity('Admin').attach(memoEval((self)=>self.$countersinks.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$featureSettings', true).withEntity('Admin').attach(memoEval((self)=>self.$featureSettings.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$presets', true).withEntity('Admin').attach(memoEval((self)=>self.$presets.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$presetCategories', true).withEntity('Admin').attach(memoEval((self)=>self.$presetCategories.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$recipes', true).withEntity('Admin').attach(memoEval((self)=>self.$recipes.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        })))
];

//# sourceMappingURL=admin.js.map